import { useNavigate, NavLink, Outlet } from "react-router-dom";
import { Shield, ArrowLeft, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import NotAllowed from "@/pages/NotAllowed";

export default function OpsShell() {
  const navigate = useNavigate();
  const { user, checked, logout } = useAuth();

  if (!checked) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground font-mono text-sm">Loading…</div>;
  if (!user?.is_platform_admin) return <NotAllowed />;

  const tab = ({ isActive }) => `rounded-md px-3 py-1.5 text-sm transition-colors ${isActive ? "bg-amber-500/15 text-amber-500" : "text-muted-foreground hover:text-foreground"}`;

  return (
    <div className="min-h-screen bg-background">
      <header className="h-14 border-b border-border/60 flex items-center justify-between px-6 sticky top-0 bg-card/60 backdrop-blur z-40">
        <div className="flex items-center gap-3">
          <Logo showText={false} />
          <span className="text-sm font-mono uppercase tracking-[0.2em] text-rose-500 flex items-center gap-1.5"><Shield className="h-4 w-4" /> Ops console</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">{user.email}</span>
          <Button size="sm" variant="outline" className="rounded-md" onClick={() => navigate("/app")} data-testid="ops-back-app"><ArrowLeft className="h-3.5 w-3.5 mr-1" /> App</Button>
          <Button size="sm" variant="ghost" className="text-rose-500" onClick={async () => { await logout(); navigate("/"); }}><LogOut className="h-3.5 w-3.5" /></Button>
        </div>
      </header>

      <div className="max-w-6xl mx-auto p-6">
        <div className="flex gap-1.5 mb-6">
          <NavLink to="/ops" end className={tab} data-testid="ops-tab-orgs">Organizations</NavLink>
          <NavLink to="/ops/requests" className={tab} data-testid="ops-tab-requests">Demo requests</NavLink>
          <NavLink to="/ops/demos" className={tab} data-testid="ops-tab-demos">Demo orgs</NavLink>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
